import {
    ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RELATORIO_ITINERARIOS,
} from '../types';

export default function alterarRegistrosPorPaginaRelatorioItinerarios(valor) {
    return {
        type: ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RELATORIO_ITINERARIOS,
        payload: valor
    };
}
